import { axios } from 'app-zephyr-axios';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

// mutator used by the generated code
export default function <T>(config: AxiosRequestConfig, extra?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return axios.request({ ...config, ...extra });
}
